import { useCallback, useEffect, useState } from "react";

const LS_KEY = "raise_admin_getting_started_dismissed";

function readDismissed(): boolean {
  try {
    return localStorage.getItem(LS_KEY) === "true";
  } catch {
    return false;
  }
}

export function useGettingStartedDismissed() {
  const [dismissed, setDismissed] = useState(readDismissed);

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(LS_KEY, "true");
    } catch {
      // storage unavailable
    }
    setDismissed(true);
    // Sync other instances in the same tab
    window.dispatchEvent(new StorageEvent("storage", { key: LS_KEY, newValue: "true" }));
  }, []);

  const restore = useCallback(() => {
    try {
      localStorage.removeItem(LS_KEY);
    } catch {
      // storage unavailable
    }
    setDismissed(false);
    window.dispatchEvent(new StorageEvent("storage", { key: LS_KEY, newValue: null }));
  }, []);

  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === LS_KEY) {
        setDismissed(e.newValue === "true");
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return { dismissed, dismiss, restore };
}
